import {useUserStore} from "@/stores/UserStore";

export default function authHeader() {
    const userStore = useUserStore()

    if (userStore.accessToken) {
        return {Authorization: 'Bearer ' + userStore.accessToken};
    } else {
        return {};
    }

}
